// Checks if a given path matches a given href with an optional trailing parameter
export const checkUrlMatch = (href: string, path: string) => {
  const regex = new RegExp(`(${href})[^|]*$`);
  return regex.test(path);
};
